import {useLinkTo} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {FaChevronCircleRight, FaComment} from 'react-icons/fa';
import {Dimensions, FlatList, View, StyleSheet} from 'react-native';
import {ListItem} from 'react-native-elements';
import {toast} from 'react-toastify';
import {listAllComplaintsSubCategories} from '../../network/Network';
import HomeHeader from '../../components/HomeHeader';
import Loading from '../../components/Loading';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

function ItemView(props) {
  
  const linkTo = useLinkTo();
  
  const onPress = (item) => {
    linkTo(
      '/customers/file_complaint/?catid=' + props.catid + '&subcatid=' + props.item.id,
    );
  };

  return (
    <ListItem
      onPress={onPress}
      bottomDivider
      containerStyle={{backgroundColor: '#e10808'}}
      style={{margin: 10}}>
      <FaComment color="white" />
      <ListItem.Content>
        <ListItem.Title
          allowFontScaling={true}
          numberOfLines={1}
          style={{color: 'white', fontWeight: 'bold'}}>
          {props.item.name}
        </ListItem.Title>
      </ListItem.Content>
      <FaChevronCircleRight color="white" />
    </ListItem>
  );
}

export default function SubCategoryComplaintScreen(props) {
  
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listAllComplaintsSubCategories(props.route.params.id)
      .then((reply) => {
        if (reply.success && (reply.status == 200 || reply.status == 201)) {
          setSubCategories(reply.data);
          setLoading(false);
        }
      })
      .catch((tr) => {
        console.log(tr);
        toast('Error, please try again');
        setLoading(false);
      });
  }, [props]);

  const keyExtractor = (item, index) => index.toString();

  const renderer = ({item, index}) => (
    <ItemView
      navigation={props.navigation}
      item={item}
      index={index}
      catid={props.route.params.id}
    />
  );

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation} />
      {loading == true ? (
        <View style={styles.indicatorStyle}>
          <Loading />
        </View>
      ) : (
        <View style={styles.container}>
          <View style={styles.content}>
            <FlatList
              data={subCategories}
              keyExtractor={keyExtractor}
              renderItem={renderer}/>
          </View>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT
  },
  indicatorStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  container: {
    flex: 1,
    alignItems: 'center',
  },
  content:{
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 2,
    paddingVertical: 16,
  }
});